import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

class DidYouMeanComboComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldValue: props.fieldValue
    };
  }

  componentDidUpdate(prevProps) {
    const { fieldValue } = this.props;
    if (prevProps.fieldValue !== fieldValue) {
      this.setState({ fieldValue });
    }
  }

  onDidYouMeanChange(event) {
    const { input } = this.props;
    this.setState({ fieldValue: event.target.value });
    if (input.onChange) {
      input.onChange(event);
    }
  }

  render() {
    const { fieldValue } = this.state;
    const { name, containerClassName, className, showError, items, input, meta, disabled, id } = this.props;

    return (<div className={ `didyoumeancombo ${ containerClassName }` }>
      <select
        name={ name }
        className={ `${ className } ${ showError && meta && meta.touched && meta.error && 'is-error' }` }
        { ...input }
        value={ fieldValue }
        disabled={ disabled }
        onChange={ event => this.onDidYouMeanChange(event) }
        id={ id }
      >
        {!items.map(item => item.trim()).includes(fieldValue) && <option disabled value={ fieldValue }>{ fieldValue }</option> }
        <option value="">Select to clear the field...</option>
        { items && items.length > 0 && items.map(item => <option key={ item.replace(' ', '_') } value={ item }>{ item }</option>) }
      </select>
      {
      showError && meta && meta.touched && (
        (meta.error && <p className="form-input-hint">{ meta.error }</p>)
        || (meta.warning && <p className="form-input-hint">{ meta.warning }</p>)
      )
    }
    </div>);
  }
}

DidYouMeanComboComponent.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  fieldValue: PropTypes.string,
  containerClassName: PropTypes.string,
  showError: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.string).isRequired, // eslint-disable-line react/forbid-prop-types
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string
  }),
  disabled: PropTypes.bool,
  id: PropTypes.string
};

DidYouMeanComboComponent.defaultProps = {
  name: '',
  className: null,
  containerClassName: null,
  showError: false,
  fieldValue: null,
  meta: null,
  disabled: false,
  id: null
};

function mapStateToProps(state, ownProps) {
  const fieldValue = ownProps.input && ownProps.input.value;
  return {
    fieldValue
  };
}

// eslint-disable-next-line import/prefer-default-export
export const DidYouMeanCombo = connect(
  mapStateToProps
)(DidYouMeanComboComponent);
